export default "__VITE_ASSET__CXzNoo6b__"